import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from './tabular-type.copysource';
import { TrinoDataset } from 'app/model/dataset/trino.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.trino.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(TrinoDataset) }
})
export class TrinoCopySource extends TabularCopySource {
}

